<template>
  <div class="flex items-center bg-depth-1 rounded-md">
    <div class="px-4 py-3 text-rhino">
      <fa-icon :icon="faMagnifyingGlass" class="size-4" aria-hidden="true" />
    </div>
    <input
      data-testid="mod-search-input"
      type="text"
      class="flex-1 bg-transparent py-3 text-mouse placeholder:text-rhino outline-none"
      :placeholder="$t('landingpage/mods/search/placeholder')"
      aria-label="Search"
      :value="searchTerm"
      @input="handleInput"
    />
    <button
      v-if="searchTerm.length > 0"
      type="button"
      class="px-4 py-3 text-rhino hover:text-mouse transition-colors"
      aria-label="Clear search"
      @click="resetInput"
    >
      <fa-icon class="size-4" :icon="faTimes" aria-hidden="true" />
    </button>
  </div>
</template>

<script setup lang="ts">
import { faMagnifyingGlass, faTimes } from '@fortawesome/pro-solid-svg-icons';

const props = withDefaults(
  defineProps<{
    value?: string;
  }>(),
  {
    value: '',
  },
);

const emit = defineEmits<{
  (e: 'change', val: string): void;
}>();

const searchTerm = ref(props.value);

const handleInput = useDebounceFn((event: Event) => {
  searchTerm.value = (event.target as HTMLInputElement).value;
  emit('change', searchTerm.value);
}, 150);

const resetInput = () => {
  searchTerm.value = '';
  emit('change', searchTerm.value);
};
</script>
